import PropTypes from 'prop-types';
import GoFetch from '~/js/modules/fetch-wrapper';

const itemOnAddFetch = new GoFetch();

export default class WishListItem extends React.Component {
    static propTypes = {
        // userId: PropTypes.number,
        updateWishListHandler: PropTypes.func,
        modalUpdateHandler: PropTypes.func,
        isSuccessAddedHandler: PropTypes.func,
        wishListData: PropTypes.object,
        isAddItem: PropTypes.bool,
        itemDetails: PropTypes.object,
        userId: PropTypes.number,
        getModifiedWishList: PropTypes.func
        // attributeId: PropTypes.number
    };
    static defaultProps = {
        modalUpdateHandler: () => null,
        isSuccessAddedHandler: () => null,
        updateWishListHandler: () => null,
        getModifiedWishList: () => null,
        isAddItem: false,
        wishListData: {},
        itemDetails: {},
        userId: null
    };
    constructor() {
        super();
    }
    _addToWishList = (event)  => {
        event.preventDefault();
        const { wishListData, itemDetails, userId, updateWishListHandler, isSuccessAddedHandler, getModifiedWishList } = this.props;
        const requestBody = {
            wishListId: `${wishListData.id}`,
            userId: `${userId}`,
            regionId: `${wishListData.regionId}`,
            items: [
                {
                    price: `${itemDetails.price}`,
                    quantity: `${itemDetails.quantity}`,
                    attributeId: `${itemDetails.currentAttributeId}`
                }
            ]
        };

        _.loaderHelper();
        $.magnificPopup.close();

        $.ajax({
            url: '/wishlist/save/',
            type: 'POST',
            contentType: 'application/json',
            data: JSON.stringify(requestBody)
        })
        .done((result) => {
            isSuccessAddedHandler(true);
            getModifiedWishList(wishListData.name);
            updateWishListHandler(result.data.saveWishListResult);
            this._fetchItemDetails(itemDetails.currentAttributeId);
            _.loaderHelper(false);
        })
        .fail((textStatus, errorThrown) => console.warn(errorThrown));

    };
    _viewWishList = () => {
        window.location = `/en/weddings/ideas/wishlist/?wishListId=${this.props.wishListData.id}`;
    };
    _fetchItemDetails = (attributeId) => {
        const { userId } = this.props;
        const requestBody = { attributeId, userId };
        const itemContent = document.querySelector('.item-details');

        $('.sk-loader-item').show();
        itemContent.classList.add('hide');
        itemOnAddFetch.post('/weddingStyler/item/details/', null, requestBody)
            .then(response => {
                this._setDefaultDetails(response.data.itemDetails, attributeId);
            })
            .then(() => itemContent.classList.remove('hide'))
            .then(() => $('.sk-loader-item').hide())
            .catch((err) => console.warn(err));
    };
    _setDefaultDetails = (fetchDetails, attributeId) => {
        fetchDetails.currentAttributeId = attributeId;
        // fetchDetails.price = this.props.itemDetails.price ? this.props.itemDetails.price : 0;
        fetchDetails.total = this.props.itemDetails.total;
        fetchDetails.destinationPrice = this.props.itemDetails.destinationPrice;
        fetchDetails.currentRegionId = this.props.itemDetails.currentRegionId;
        fetchDetails.hiddenPriceFlag = this.props.itemDetails.priceList[0].hiddenPrice;
        fetchDetails.quantity = this.props.itemDetails.quantity;
        fetchDetails.quantityAdded = this.props.itemDetails.quantity;

        this.props.modalUpdateHandler(fetchDetails);
    };

    render() {
        const { wishListData, isAddItem } = this.props;
        const { name, itemCount, lastUpdate } = wishListData;

        return (
           <div className="row wl-item">
                <div className="col-xs-12 col-sm-9 info">
                    <div className="row">
                        <strong className="col-xs-12 wishlist-title">{ name }</strong>
                        { itemCount > 0
                            ? <span className="col-xs-12 item-count">{`${itemCount} Items total, Last saved ${lastUpdate}`}</span>
                            : <span className="col-xs-12 item-count">{`${itemCount} Items total, Wishlist created ${lastUpdate}`}</span>
                        }
                    </div>
                </div>
                <div className="col-xs-12 col-sm-3 add-wrapper">
                    <a onClick={ isAddItem ? this._addToWishList : this._viewWishList } className="add-it">{ isAddItem ? 'add it here' : 'View'}</a>
                </div>
            </div>
        );
    }
}
